// 定义消息
const messages = {
    en: {
        message: {
            hello: 'hello world'
        }
    },
    zh: {
        message: {
            hello: '你好，世界'
        }
    }
};

export { messages };
